<template>
  <div>
    <div class="around-fade"></div>
    <div class="zone-modal">
      <b-overlay
        class="declaration-overlay"
        rounded="lg"
        :show="!dataLoaded && !!clonedDeclarationId"
        v-if="!dataLoaded && !!clonedDeclarationId"
      />

      <CloseModalButton :on-click="closeCloneDeclarationModal"></CloseModalButton>

      <div class="header">
        <h1>Powiel deklarację do nowego budynku</h1>
      </div>

      <div v-if="declaration != null">
        <div style="height: 10em; overflow-y: auto">
          <div>Deklaracja {{ declaration.type }} dla budynku {{ declaration.address }}.</div>
          <div>
            <b>W deklaracji zostały wskazane następujące źródła ciepła:</b>
            <ul>
              <li v-for="s in declaration.sohs" :key="s">{{ s }}</li>
              <li v-if="declaration.sohs.length == 0">nie podano</li>
            </ul>
          </div>
          <div v-if="declaration.solid_fuel">
            klasy kotłów:
            <ul>
              <li v-for="s in declaration.sfbccs" :key="s">{{ s }}</li>
              <li v-if="declaration.sfbccs.length == 0">nie podano</li>
            </ul>
          </div>
          <div v-if="declaration.solid_fuel">
            rodzaje paliw:
            <ul>
              <li v-for="s in declaration.sfufs" :key="s">{{ s }}</li>
              <li v-if="declaration.sfufs.length == 0">nie podano</li>
            </ul>
          </div>
          <div v-if="declaration.type == 'B'">
            typy budynków:
            <ul>
              <li v-for="s in declaration.btypes" :key="s">{{ s }}</li>
              <li v-if="declaration.btypes.length == 0">nie podano</li>
            </ul>
          </div>
          <div>
            <span v-if="declaration.after_01_07_2021">Źródło ciepła / spalania paliw uruchomiono po 1 lipca 2021 r. </span>
            <span v-if="!declaration.after_01_07_2021">Źródło ciepła / spalania paliw uruchomiono przed 1 lipca 2021 r. </span>
            <span v-if="(declaration.type == 'B') && (declaration.special_symbol)">Symbol / oznaczenie specjalne budynku: {{ declaration.special_symbol }}. </span>
            <span v-if="(declaration.type == 'A') && (declaration.is_single_family)">Deklaracja dotyczy budynku jednorodzinnego. </span>
            <span v-if="(declaration.type == 'A') && (declaration.is_multi_family)">Deklaracja dotyczy budynku wielorodzinnego. Liczba wszystkich lokali mieszkalnych w budynku wynosi {{ declaration.multi_family_count }}. </span>
            <span v-if="(declaration.type == 'A') && (declaration.is_temporary)">Deklaracja dotyczy budynku zbiorowego zamieszkania. Liczba wszystkich lokali mieszkalnych w budynku wynosi {{ declaration.temporary_count }}. </span>
            <span v-if="declaration.is_all_premises">Deklaracja dotyczy wszystkich lokali w budynku. </span>
            <span v-if="(declaration.type == 'A') && (!declaration.is_all_premises)">Deklaracja dotyczy wybranych lokali w budynku (liczba: {{ declaration.premises_count }}, numery: {{ declaration.premises_list}}). </span>
            <span v-if="(declaration.type == 'B') && (!declaration.is_all_premises)">Deklaracja dotyczy wybranych lokali w budynku (numery: {{ declaration.premises_list}}). </span>
          </div>
        </div>

        <div class="mt-2">
          <div><b>Wskaż budynek do kopiowanej deklaracji:</b></div>

          <label class="mr-3">
            <input
              value="A"
              type="radio"
              v-model="declarationType"
            />
            Budynki i lokale mieszkalne
          </label>

          <label>
            <input
              value="B"
              type="radio"
              v-model="declarationType"
            />
            Budynki i lokale niemieszkalne
          </label>

          <b-form-select
            v-if="buildings != null"
            v-model="buildingData"
            :options="buildingsFormatted"
            :select-size="4"
          />

          <b-form-select
            v-if="buildings == null"
            disabled="disabled"
            :options="[{value: -1, text: 'Wczytuję budynki...' }]"
            :select-size="4"
          />

          <b-form-input v-model="search" placeholder="Wyszukaj budynek" class="mt-1"></b-form-input>
        </div>
      </div>

      <div class="buttons-row">
        <button type="button" class="btn btn-outline-primary" @click="openBuildingsModal" style="float: left">
          Dodaj budynek
        </button>
        <button type="button" class="btn btn-outline-primary" @click="closeCloneDeclarationModal()">
          Zamknij
        </button>
        <button type="button" class="btn btn-primary" @click="cloneFinal()" :disabled="(buildingData == '') || (declaration == null) || (declaration.type != declarationType)">
          Złóż (edycja dekl.)
        </button>
        <button type="button" class="btn btn-primary" @click="cloneQuick()" :disabled="(buildingData == '') || (declaration == null) || (declaration.type != declarationType)">
          Złóż
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import DeclarationsModel from "@/models/declarations";
import LocationsModel from "@/models/locations";
import DeclarationsMixin from "@/mixins/DeclarationsMixin";
import CloseModalButton from "@/components/common/CloseModalButton";
import _ from "lodash";
import axios from "axios";

export default {
  name: "CloneDeclarationModal",
  components: { CloseModalButton },
  mixins: [DeclarationsMixin],
  data() {
    return {
      dataLoaded: false,
      declaration: null,
      declarationType: 'A',
      buildings: null,
      buildingData: "",
      search: ""
    }
  },
  methods: {
    closeCloneDeclarationModal() {
      this.$store.commit("closeCloneDeclarationModal");
    },
    cloneFinal() {
      this.buildingData.declarationType = this.declarationType;
      this.$store.commit("setDeclarationBuilding", this.buildingData);
      this.$store.commit("setDeclarationClonedFinalId", this.$store.state.clonedDeclarationId);
      this.$store.commit("closeCloneDeclarationModal");
      this.$store.commit("openDeclarationModal");
    },
    cloneQuick() {
      DeclarationsModel.cloneDeclaration(this.$store.state.clonedDeclarationId, this.buildingData.id)
        .then((res) => {
          this.$store.commit("closeCloneDeclarationModal");
          this.$store.commit('updateDeclarationsList');
          this.$notify({
            group: 'zone',
            type: 'success',
            title: 'Sukces',
            text: 'Złożono deklarację dla nowego budynku'
          });
        });
    },
    openBuildingsModal() {
      this.$store.commit("openBuildingsModal");
    },
    loadBuildings() {
      this.buildings = null;
      return axios.get('/api/locations/buildings').then((rres) => {
        this.buildings = rres.data;
      });
    },
    performAddressSearch: _.debounce(function() {
      var srch = this.search.trim();
      this.buildings = null;
      if (srch.length) {
        LocationsModel.getUserBuildings(0, -1, -1, false, srch)
          .then((res) => this.buildings = res.data);
      } else {
        return axios.get('/api/locations/buildings').then((rres) => {
          this.buildings = rres.data;
        });
      }
    }, 500)
  },
  computed: {
    clonedDeclarationId() {
      return this.$store.state.clonedDeclarationId;
    },
    buildingsFormatted() {
      let result = [];
      if (this.buildings !== null) {
        this.buildings.forEach((building) => {
          result.push({
            value: building,
            text: building.formatted_address
          });
        })
      }
      return result;
    }
  },
  mounted() {
    if (this.clonedDeclarationId) {
      DeclarationsModel.getDeclarationSummaryById(this.clonedDeclarationId)
        .then((res) => {
          this.declaration = res.data;
          this.dataLoaded = true;
          return this.loadBuildings();
        });
    }

    var obj = this;
    this.$root.$on('reloadBuildingsIfNeeded', () => {
      obj.loadBuildings();
    });
  },
  watch: {
    "search": function () {
      this.performAddressSearch();
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, label, p {
  color: #707070;
}


.zone-modal {
  width: 44rem;
  height: 30rem;
  padding: 1.5rem;
  z-index: 10000;
}

.header {
  grid-column-start: 1;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 1;
}

h1 {
  font-size: 1.3rem;
}

h2 {
  font-size: 1.2rem;
  font-family: "Volte Semibold", serif;
}

.zone-modal .buttons-row {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  display: block;
  width: 96%;
  text-align: right;
  white-space: nowrap;
}

.buttons-row .btn-primary, .buttons-row .btn-outline-primary {
  min-width: 8rem;
  margin-left: 1rem;
  height: 2rem;
}

.declaration-overlay {
  position: absolute !important;
  top: 4rem;
  left: 0;
  right: 0;
  bottom: 0;
}

@media (max-height: 770px) {
  .zone-modal {
    height: 30rem;
  }
}

.table {
  width: 100%;
}
</style>
